import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractFormulaNode from "./AbstractFormulaNode.js";

/**
 * `naFormulaNode` is a concrete implementation of `abstractFormulaNode`
 * representing a N/A node. This is used to represent an empty formula.
 */

/**
 * TODO: write documentation
 */
export default class NaFormulaNode extends AbstractFormulaNode {
	accept(visitor, additionalInformation) {
		return visitor.visitNaNode(this, additionalInformation);
	}

	isLeaf() {
		return true;
	}

	validate({ collector }) {
		collector.addError(_("Invalid formula"));
	}

	add(node) {
		return node;
	}

	removeLastNode() {
		return this;
	}

	removeLastNodeFrom(node) {
		return node.getLeftOperand();
	}

	removeLastNodeFromSum(node) {
		return new node.constructor({
			operands: node.getOperands().slice(0, -1),
		});
	}

	static getType() {
		return "NaExpression";
	}
}
